/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deletePipeSeriesPipeseriesidPipesPipeidPathPipeSeriesIdSchema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidPathPipeIdSchema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidStatus204Schema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidStatus400Schema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidStatus401Schema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidStatus404Schema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidStatus500Schema = z.string()

export const deletePipeSeriesPipeseriesidPipesPipeidResponseSchema = deletePipeSeriesPipeseriesidPipesPipeidStatus204Schema

export const deletePipeSeriesPipeseriesidPipesPipeidErrorSchema = z.union([deletePipeSeriesPipeseriesidPipesPipeidStatus400Schema, deletePipeSeriesPipeseriesidPipesPipeidStatus401Schema, deletePipeSeriesPipeseriesidPipesPipeidStatus404Schema, deletePipeSeriesPipeseriesidPipesPipeidStatus500Schema])

export const deletePipeSeriesPipeseriesidPipesPipeidPathSchema = z.object({
  pipeSeriesId: z.string(),
  pipeId: z.string(),
})
